import { Div, Text, Range, Span, Ref, RefBool, Button } from '@tblabs/truffle';


export class VolumeButton extends Button
{
    constructor(volume: number, playerVolume: Ref<number>, showVolumeControler: RefBool)
    {
        super(volume + "%");

        this.Style(`flex: 1; text-align: center; height: 60px;`);

        this.OnClick(() =>
        {
            playerVolume.value = volume;
            showVolumeControler.False();
        });
    }
}

export class VolumeControler extends Div
{
    constructor(playerVolume: Ref<number>, showVolumeControler: RefBool)
    {
        super();
        this.PositionFixed().Bottom(0).Left(0)
            .WidthPercent(100).ZIndex(100)
            .Background("#222")
            .TextAlignCenter()
            .Padding(18)
            .PaddingBottom(48)

        this.Append(
            new Text(playerVolume, v => `Volume: ${v}%`).FontSize(24).Color("#f8f8f8").MarginTop(32),
            "\n",
            new Range(playerVolume, [0, 100]).WidthPercent(90).MarginTop(24),
            new Div().Append(
                new VolumeButton(5, playerVolume, showVolumeControler),
                new VolumeButton(10, playerVolume, showVolumeControler),
                new VolumeButton(50, playerVolume, showVolumeControler),
                new VolumeButton(100, playerVolume, showVolumeControler),
            ).Style(`display: flex; gap: 32px; margin-top: 32px; width: 80%; align-items: center; justify-content: center; margin: 32px auto;`),
            new Span("×").OnClick(() => showVolumeControler.False()).CursorPointer().FontSize(32).PositionAbsolute().Top().Right(16).Color("red"),
        );
    }
}
